var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jCPixT"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.1,18.41H1.89s-.58-.23-.67-.28c-.68-.37-1.06-1.11-1.12-1.87-.32-4.07.25-8.56,0-12.68.13-1.14,1.01-1.97,2.15-2.08h19.53c1.16.05,2.14.98,2.22,2.15v12.61c-.11,1.08-.92,2-2.01,2.15l-8.14.02-5.9,4c-.24.2-.85-.08-.85-.34v-3.68ZM8.26,20.81l5.23-3.55,8.36-.02c.53-.06.98-.6.98-1.13-.23-3.99.29-8.3,0-12.24-.05-.67-.37-1.1-1.06-1.2H2.4c-.61.02-1.11.51-1.13,1.13v12.32c.03.49.32,1.04.85,1.12,1.62.25,3.85-.19,5.53,0,.2.02.62.17.62.4v3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.43,8.04c-.38.38-.96.08-1-.45-.07-.86.62-1.89,1.36-2.28,2.12-1.11,4.52.86,3.74,3.16-.4,1.19-1.77,1.59-1.9,2.84-.06.58.29,2.17-.81,1.82-.52-.17-.4-1.62-.34-2.1.19-1.57,1.29-1.73,1.84-2.75,1.01-1.87-2.09-3.15-2.72-.97-.06.21,0,.54-.18.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.89,14.34c.85-.19,1,.99.33,1.14-.85.19-1-.99-.33-1.14Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/help.a99187226223100090aebc6bf6c5f3e2.svg";